import * as React from "react";
import { ResponsiveGraph } from "./ResponsiveGraph";
import SplitPane from "react-split-pane";
import memoize from "memoize-one";
import { checkGlobalExtend4Axis } from "./utils";
import { ExtendHandler } from "./ExtendHandler";
import { AxisMode } from "./interfaces/axis";
import { MarginContextContainer } from "./Containers/MarginContextContainer";
export class GraphsGroup extends React.Component {
    constructor(props) {
        super(props);
        this.recursiveStruct = memoize((struct, hasCommonExtend) => {
            let finalSplitPanel = [];
            let subSplitPanel;
            let splitDirection;
            if (Array.isArray(struct)) {
                struct.forEach((element, index) => {
                    if (element.type === "container") {
                        switch (element.alignment) {
                            case "horizontal":
                                splitDirection = "vertical";
                                break;
                            case "vertical":
                                splitDirection = "horizontal";
                                break;
                            default:
                                break;
                        }
                        subSplitPanel = this.recursiveStruct(element.items, hasCommonExtend);
                        finalSplitPanel.push(React.createElement(SplitPane, { key: index, split: splitDirection, minSize: 50, maxSize: -50, size: element.items[0].fraction
                                ? `${element.items[0].fraction * 100}%`
                                : `${100 / element.items.length}%` }, subSplitPanel));
                    }
                    else if (element.type === "item") {
                        const graph = this.props.tab.graphs.filter((graph) => graph.id === element.content)[0];
                        finalSplitPanel.push(React.createElement("div", { style: { height: "100%", width: "100%", overflow: "hidden" }, key: index },
                            React.createElement(ExtendHandler, { hasXProvider: !hasCommonExtend, hasYprovider: true },
                                React.createElement(MarginContextContainer, null,
                                    React.createElement(ResponsiveGraph, { hideTitle: this.props.hideTitle, ignoreFileName: this.props.ignoreFileName, data: this.props.data, graph: graph, folderType: this.props.folderType, baseFileName: this.props.baseFileName })))));
                    }
                });
            }
            else {
                if (struct.type === "container") {
                    switch (struct.alignment) {
                        case "horizontal":
                            splitDirection = "vertical";
                            break;
                        case "vertical":
                            splitDirection = "horizontal";
                            break;
                        default:
                            break;
                    }
                    return (React.createElement(SplitPane, { split: splitDirection, minSize: 50, maxSize: -50, size: struct.items[0].fraction
                            ? `${struct.items[0].fraction * 100}%`
                            : `${100 / struct.items.length}%` }, this.recursiveStruct(struct.items, hasCommonExtend)));
                }
            }
            return finalSplitPanel;
        });
        this.checkGlobalExtend = memoize(checkGlobalExtend4Axis);
    }
    render() {
        const { tab } = this.props;
        if (tab.struct.type === "item") {
            return this.props.tab.graphs.map((graph, index) => {
                if (!graph.title) {
                    graph.title = tab.title;
                }
                return (React.createElement(ExtendHandler, { hasXProvider: true, hasYprovider: true, key: index },
                    React.createElement(MarginContextContainer, null,
                        React.createElement(ResponsiveGraph, { hideTitle: this.props.hideTitle, ignoreFileName: this.props.ignoreFileName, data: this.props.data, graph: graph, folderType: this.props.folderType, baseFileName: this.props.baseFileName }))));
            });
        }
        const hasCommonExtend = this.checkGlobalExtend(tab, AxisMode.Date);
        const complexStruct = this.recursiveStruct(tab.struct, hasCommonExtend);
        return (React.createElement(ExtendHandler, { hasXProvider: hasCommonExtend, hasYprovider: false, children: complexStruct }));
    }
}
//# sourceMappingURL=GraphGroup.js.map